export class OTTSwitchCardSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      color: '#000000',
      align: 'left',
      font: {
        fontSize: 14,
        fontWeight: '400',
        color: '#000000',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      height: {
        type: 'auto',
        value: 1
      },
      padding: {
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 10,
        paddingBottom: 10
      },
      margin: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10
      },
      text: 'Text',
      choice_options: [],
      width: {
        type: 'auto',
        value: 100
      },
      link: {
        fontWeight: '400',
        color: '#0000ff',
        textDecoration: 'none'
      },
      hover: {
        fontWeight: '400',
        color: '#0000ff',
        textDecoration: 'underline'
      },
      languages: {},
      selectedLanguage: '',
      startFocus: false,
      switchOnColor: '#47d747',
      switchOffColor: '#cccccc',
      border: {
        borderWidth: 1,
        borderColor: '#70707078',
        borderStyle: 'solid'
      }
    };
    Object.assign(this, defaults, overrides);
  }
}
export const OTTSwitchCardTypes = {
  content: {
    text: {
      title: 'Text',
      type: 'TextLanguage'
    }
  },
  settings: {
    startFocus: {
      title: 'First Focused Item',
      type: 'Switch'
    }
  },
  orientation: {
    height: {
      title: 'Height',
      type: 'Size'
    },
    align: {
      title: 'Text Align',
      type: 'Align'
    },
    width: {
      title: 'Width',
      type: 'Size'
    },
    padding: {
      title: 'Inner Spacing',
      type: 'Padding'
    },
    margin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  styles: {
    font: {
      title: 'Font',
      type: 'Font'
    },
    background: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    border: {
      title: 'Border',
      type: 'Border'
    }
  },
  links: {
    link: {
      title: 'Link Style',
      type: 'Links'
    },
    hover: {
      title: 'Hover Style',
      type: 'Links'
    }
  },
  'toggle switch style': {
    switchOnColor: {
      title: 'ON Color',
      type: 'ColorPicker'
    },
    switchOffColor: {
      title: 'OFF Color',
      type: 'ColorPicker'
    }
  }
};